import { FC } from 'react';
import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { filterHistoricEventDatesFromFirstEvent } from '../utils/OpmInputHelper';

interface EmptyHistoricCellsProps {
  indexIdentifier: string;
  className?: string | undefined;
}

const OpmInputEmptyHistoricCells: FC<EmptyHistoricCellsProps> = ({
  indexIdentifier,
  className = undefined,
}) => {
  const opmInputResults = useAppSelector((state) => state.opmCalculation.calculatedInputs);
  const showHistoricDataColumns = useAppSelector(
    (state) => state.uiValues.userSelections.opmInputs.showHistoricDataColumns
  );
  const filteredHistoricYears = filterHistoricEventDatesFromFirstEvent(
    opmInputResults.historicEventDates
  );
  const historicDatesArray = Object.keys(filteredHistoricYears);

  if (!showHistoricDataColumns) {
    return null;
  }

  return (
    <>
      {historicDatesArray.map((_, index) => (
        <td key={index + `historic-${indexIdentifier}`} className={className} />
      ))}
    </>
  );
};

export default OpmInputEmptyHistoricCells;
